// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_rRT","newExpiryDate":"styles_newExpiryDate__2Ymr7","footer":"styles_footer__3gwFy"};